module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Medarbejdere",
      "identifier": "employees"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Medarbejdere</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine medarbejdere\n            ")])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72e01a76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/employees.vue
// module id = 899
// module chunks = 0